import { connect } from 'react-redux';
import * as R from 'ramda';
import Sidebar from './Sidebar';
import {
  getParentCompanies,
  getParentCompaniesIndex,
  getParentCompaniesPending,
  setAffiliates,
  setMobileSidebarOpen,
  setParentCompaniesIndex,
  setUserAffiliateTable,
} from '../securitySlice';

const mapStateToProps = R.applySpec({
  parentCompanies: getParentCompanies,
  parentCompaniesIndex: getParentCompaniesIndex,
  parentCompaniesPending: getParentCompaniesPending,
});

export default connect(mapStateToProps, {
  setAffiliates,
  setMobileSidebarOpen,
  setParentCompaniesIndex,
  setUserAffiliateTable,
})(Sidebar);
